import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import type {
  ContractDto,
  NM_LocationFacility,
  NetworkDto,
  ProductDto,
  ProductServiceDto,
  RoleResponse,
  TeamResponse
} from 'caseflow/api.dtos';

import { computed } from 'mobx';

export class TeamsCache extends CacheStore<TeamResponse> {
  constructor() {
    super('cf_teams');
  }

  @computed get Current() {
    return this.All.filter((x) => x.isCurrent);
  }
}

export class ContractsCache extends CacheStore<ContractDto> {
  constructor() {
    super('cf_contracts');
  }
}

export class CaseflowReportsCache extends CacheStore<ProcessDto> {
  constructor() {
    super('cf_reports');
  }
}

export class RolesCache extends CacheStore<RoleResponse> {
  constructor() {
    super('cf_roles');
  }
}

export class ProductCache extends CacheStore<ProductDto> {
  constructor() {
    super('cf_products');
  }
}
export class ProductServiceCache extends CacheStore<ProductServiceDto> {
  constructor() {
    super('cf_p_service');
  }
}
export class NetworksCache extends CacheStore<NetworkDto> {
  constructor() {
    super('cf_networks');
  }
}

export class FacilityCache extends CacheStore<NM_LocationFacility> {
  constructor() {
    super('cf_facilities');
  }
}
